<template>
    <button class="btn btn-primary" @click="home()"><i class="fas fa-home me-2"></i>Home</button>
</template>

<script>
export default {
    methods: {
        home: function() {
            this.$router.push('/');
        }
    }
}
</script>